import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import type { ButtonProps } from '@xing-com/button';
import { IconComment } from '@xing-com/icons';

type CommentReactionButtonProps = ButtonProps &
  CommentReactionProps & {
    compact?: boolean;
    commentClick?(): void;
  };

type CommentReactionProps =
  | CommentReactionAnchorProps
  | CommentReactionLinkProps;

type CommentReactionAnchorProps = {
  href?: string;
  to?: never;
};

type CommentReactionLinkProps = {
  href?: never;
  to?: string;
};

export const CommentReactionButton: FC<CommentReactionButtonProps> = ({
  onClick,
  compact = false,
  href,
  to,
}) => {
  return (
    <Button
      data-testid="comment-button"
      icon={IconComment}
      onClick={onClick}
      {...(to ? { to: to } : { href: href })}
    >
      {!compact && <FormattedMessage id="COMMENT_BUTTON_LABEL" />}
    </Button>
  );
};
